'use client';

import React from 'react';
import { clearAuthLocalStorage } from '@/lib/auth/logout';

interface SignOutFormProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * The one sign-out form: POST /auth/signout, clearing the stored auth state first.
 * CRITICAL: localStorage is cleared in the submit handler, before the browser sends the
 * POST, so stale role data never survives a sign-out.
 */
export function SignOutForm({ className, children }: SignOutFormProps) {
  return (
    <form action="/auth/signout" method="post" onSubmit={() => clearAuthLocalStorage()} className={className}>
      {children}
    </form>
  );
}
